import type { Middleware } from '@reduxjs/toolkit';

import { api } from '~/redux/api/createApi';
import { TagType } from '~/redux/api/TagType';
import { uploadDocumentsThunk } from '~/redux/thunks/fileUpload';

export const folderContentTag = {
  type: TagType.Folder,
  id: 'CONTENT',
} as const;

export const invalidateFolderContentTags = () =>
  api.util.invalidateTags([folderContentTag]);

export const invalidateFolderContentOnUploadMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (uploadDocumentsThunk.fulfilled.match(action)) {
      store.dispatch(invalidateFolderContentTags());
    }

    return result;
  };
